import React from 'react';
import { Outlet } from 'react-router-dom';

const HiringPreferencesRouter: React.FC = () => {
  return <Outlet />;
};

export default HiringPreferencesRouter;
